'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisclosureArrow = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisclosureArrow = exports.DisclosureArrow = function DisclosureArrow(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      open = _ref.open,
      svgClassName = _ref.svgClassName;
  return _react2.default.createElement(
    'span',
    {
      onClick: onClick,
      className: (0, _classnames2.default)('disclosure-arrow', className, {
        'disclosure-arrow--open': open
      })
    },
    _react2.default.createElement(_reactInlinesvg2.default, { className: (0, _classnames2.default)('svg', svgClassName), uniquifyIDs: false, src: require('../../../static/design-system/icons/arrow-down-small.svg') })
  );
};

DisclosureArrow.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  svgClassName: _propTypes2.default.string
};